import React from 'react';
import styled from 'styled-components';
import { theme, Icon } from 'components';
import { useBreakpoint } from 'hooks';
import { useShowingsCalendarContext } from '../ShowingsCalendarContext';

const MobileFilterHeader = () => {
  const { pendingStatus, statuses, clearStatuses } =
    useShowingsCalendarContext();
  const { md } = useBreakpoint();

  if (md) return null;
  if ((!statuses || statuses.length === 0) && !pendingStatus) return null;

  return (
    <StyledMobileFilterHeader>
      <span>Filtered by status</span>
      <PaddedIcon
        type="antdCloseCircleFilled"
        height={14}
        width={14}
        color="gray6"
        onClick={clearStatuses}
      />
    </StyledMobileFilterHeader>
  );
};

const PaddedIcon = styled(Icon)`
  padding: 10px;
`;

const StyledMobileFilterHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${theme.gray7};
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  cursor: default;
  padding-right: 14px;
  padding-left: 12px;
  box-shadow: inset 0px -1px 0px #f0f0f0;
`;

export default MobileFilterHeader;
